import '../_rollupPluginBabelHelpers-a38db067.js';
import './html-props.js';
import { svgPropsRegex } from './svg-props.js';
import { memoize } from './memoize.js';

const isSvgPropValid = /* #__PURE__ */memoize(prop => svgPropsRegex.test(prop) || prop.charCodeAt(0) === 111 /* o */ && prop.charCodeAt(1) === 110 /* n */ && prop.charCodeAt(2) < 91 /* Z+1 */);

export { isSvgPropValid };
